{
  "title": "Power Word: Kill",
  "source": "Player's Handbook",
  "levelAndSchool": "9th-level enchantment",
  "level": 9,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V",
  "duration": "Instantaneous",
  "description": [
    "You utter a word of power that can compel one creature you can see within range to die instantly. If the creature you chose has 100 hit points or fewer, it dies. Otherwise, the spell has no effect."
  ],
  "spellLists": ["bard", "sorcerer", "warlock", "wizard"]
}
